export type TransferRow = {
  year: "2022/23" | "2023/24" | "2024/25";
  fromUniversity: string;
  toUniversity: string;
  fromProgram: string;
  toProgram: string;
  count: number;
};

export const TRANSFER_ROWS: TransferRow[] = [
  {
    year: "2022/23",
    fromUniversity: "香港城市大學",
    toUniversity: "香港浸會大學",
    fromProgram: "工商管理學士(管理學)",
    toProgram: "創意產業音樂學士(榮譽)學位課程",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港城市大學",
    toUniversity: "香港科技大學",
    fromProgram: "工商管理學士(市場營銷)",
    toProgram: "理學士(定量社會數據分析)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港城市大學",
    toUniversity: "香港科技大學",
    fromProgram: "工商管理學士(榮譽)學位課程",
    toProgram: "工商管理學士(工商管理學院)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港城市大學",
    fromProgram: "工商管理學士(榮譽)學位課程 - 資訊系統及電子商貿學專修",
    toProgram: "工商管理學士(管理學)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港城市大學",
    fromProgram: "中醫學學士及生物醫學理學士(榮譽)學位課程",
    toProgram: "工學士(生物醫學工程)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港城市大學",
    fromProgram: "英國語言文學文學士(榮譽)學位課程及英語教學教育學士(榮譽)學位課程",
    toProgram: "法律學學士",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港教育大學",
    fromProgram: "工商管理學士(榮譽)學位課程",
    toProgram: "幼兒教育榮譽學士（五年全日制）",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "嶺南大學",
    toUniversity: "香港教育大學",
    fromProgram: "社會科學(榮譽)學士",
    toProgram: "特殊教育榮譽文學士（四年全日制）",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港中文大學",
    toUniversity: "香港城市大學",
    fromProgram: "工商管理學士（工商管理學士綜合課程）及法律博士雙學位課程",
    toProgram: "法律學學士",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港中文大學",
    toUniversity: "香港科技大學",
    fromProgram: "數據科學與政策研究",
    toProgram: "工學士(工學院)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港教育大學",
    toUniversity: "香港城市大學",
    fromProgram: "全球及環境研究榮譽社會科學學士（四年全日制）",
    toProgram: "社會科學學士(公共政策與政治)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港教育大學",
    toUniversity: "香港浸會大學",
    fromProgram: "創意藝術與文化榮譽文學士及音樂教育榮譽學士 (五年全日制)",
    toProgram: "音樂文學士(榮譽)學位課程",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港教育大學",
    toUniversity: "香港浸會大學",
    fromProgram: "音樂教育榮譽學士（五年全日制）",
    toProgram: "創意產業音樂學士(榮譽)學位課程",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港理工大學",
    toUniversity: "香港科技大學",
    fromProgram: "護理學理學士",
    toProgram: "工商管理學士(工商管理學院)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港理工大學",
    toUniversity: "香港科技大學",
    fromProgram: "護理學理學士",
    toProgram: "工商管理學士(專業會計學)",
    count: 1,
  },
  {
    year: "2022/23",
    fromUniversity: "香港大學",
    toUniversity: "香港城市大學",
    fromProgram: "理學士(言語及聽覺科學)",
    toProgram: "獸醫學學士",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港教育大學",
    toUniversity: "香港浸會大學",
    fromProgram: "行政管理榮譽理學士課程（兩年全日制）",
    toProgram: "傳理學學士(榮譽) 學位課程 - 公關及廣告主修",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港理工大學",
    toUniversity: "香港城市大學",
    fromProgram: "會計及金融工商管理學士",
    toProgram: "社會及行為科學系 [選項: 社會科學學士(犯罪學及社會學)、社會科學學士(心理學)、社會科學學士(社會工作)]",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港理工大學",
    toUniversity: "香港城市大學",
    fromProgram: "檢測及認證分析科學理學士",
    toProgram: "工學士(土木工程)",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港理工大學",
    toUniversity: "香港浸會大學",
    fromProgram: "化學科技理學士",
    toProgram: "傳理學學士(榮譽)學位課程",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港理工大學",
    toUniversity: "香港教育大學",
    fromProgram: "文學士學位",
    toProgram: "體育教育榮譽學士（五年全日制）",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港大學",
    toUniversity: "香港城市大學",
    fromProgram: "牙醫學士",
    toProgram: "獸醫學學士",
    count: 1,
  },
  {
    year: "2023/24",
    fromUniversity: "香港大學",
    toUniversity: "香港城市大學",
    fromProgram: "護理學學士",
    toProgram: "獸醫學學士",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港城市大學",
    toUniversity: "香港科技大學",
    fromProgram: "工商管理學士(榮譽)學位課程",
    toProgram: "工商管理學士(工商管理學院)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港城市大學",
    fromProgram: "藝術及科技文理學士(榮譽)學位課程",
    toProgram: "文理學士(新媒體)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港城市大學",
    fromProgram: "藝術及科技文理學士(榮譽)學位課程",
    toProgram: "文學士(創意媒體)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港浸會大學",
    toUniversity: "香港科技大學",
    fromProgram: "藝術及科技文理學士(榮譽)學位課程",
    toProgram: "理學士(綜合系統與設計)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "嶺南大學",
    toUniversity: "香港城市大學",
    fromProgram: "工商管理(榮譽)學士",
    toProgram: "理學士(計算數學)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港中文大學",
    toUniversity: "香港科技大學",
    fromProgram: "計算機科學與工程（大類收生課程）",
    toProgram: "工學士(工學院)",
    count: 1,
  },
  {
    year: "2024/25",
    fromUniversity: "香港理工大學",
    toUniversity: "香港浸會大學",
    fromProgram: "酒店及旅遊業管理理學士組合課程",
    toProgram: "工商管理學士(榮譽)學位課程 - 市場學專修",
    count: 1,
  },
];

export const YEAR_TOTALS: Record<TransferRow["year"], number> = {
  "2022/23": 16,
  "2023/24": 7,
  "2024/25": 7,
};
